// extracted by mini-css-extract-plugin
module.exports = {"spinWrapper":"Preview_spinWrapper__oMLCm"};